import { TeachingLoadReportType } from '@bp/planung-graphql-types';
import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TeachingLoadReportConfigurationForm } from '../forms/TeachingLoadReportConfigurationForm';

type TeachingLoadReportConfigurationModalProps = {
  isOpen: boolean;
  subType: TeachingLoadReportType;
  onClose: () => void;
};

export const TeachingLoadReportConfigurationModal = ({
  isOpen,
  subType,
  onClose,
}: TeachingLoadReportConfigurationModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      width={'s'}
      title={t('deputate.configuration.configure')}
      isOpen={isOpen}
      loading={loading}
      onRequestClose={onClose}
    >
      <TeachingLoadReportConfigurationForm subType={subType} onLoad={setLoading} onClose={onClose} />
    </Modal>
  );
};
